import iqosBleService from '../ble/iqosBleService';
import iqosHidService from '../hid/iqosHidService';
import connectivityService from './connectivityService';

export const getIqosService = () => {
    return connectivityService.isUsb() ? iqosHidService : iqosBleService;
};
